import React, { useContext } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import FactoryContext from "../../contexts/factoryContext";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useTeams from "../../hooks/queryResults/useTeams";
import Box from "../layout/Box";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import Loading from "../ui/Loading";

const StyledTrDivisionName = styled.tr`
  & th {
    background-color: ${({ colors }) => colors.first};
    color: ${({ colors }) => colors.second};
    padding: 0.5rem;
  }
`;

const TeamList = ({ path }) => {
  const { league: leagueSlugOrId, season, team: teamSlugOrId } = useParams();
  const factory = useContext(FactoryContext);
  const { leagueSeason } = useLeagueSeason();
  const { teams } = useTeams();
  const breakpoints = useContext(BreakpointContext);

  const loaded = factory && leagueSeason && teams && teams.hasLoaded();

  let divisionSeasons;
  if (loaded) {
    const divisionSeasonObjs = leagueSeason.getDivisionSeasonObjs();
    divisionSeasons = divisionSeasonObjs.map((divSeaObj) =>
      factory.makeDivisionSeason(divSeaObj)
    );
    divisionSeasons.forEach((divSea) => {
      divSea.teams = divSea.getTeams(teams);
    });
  }

  const getDivisionRow = (divSea) => {
    let divisionName;
    if (breakpoints.md) divisionName = `${divSea.obj.name} Division`;
    else if (breakpoints.sm) divisionName = `${divSea.obj.name}`;
    else divisionName = divSea.obj.abbr;

    return (
      <StyledTrDivisionName key={divisionName} colors={divSea.colors.obj}>
        <th colSpan={2} className={"center"}>
          {divisionName}
        </th>
      </StyledTrDivisionName>
    );
  };

  const getTeamRow = (team) => {
    const isActive =
      team.obj.id === teamSlugOrId || team.obj.slug === teamSlugOrId;

    let linkPath;
    if (!isActive)
      linkPath = `/${leagueSlugOrId}/${season}/${team.obj.slug}` + path;

    // team logo
    const teamLogos = factory.makeTeamLogoCollection(team);
    const teamLogo = teamLogos.getActiveLogo();
    const teamLogoImg = teamLogo.getImgSm();
    let teamLogoImgLink = <Link to={linkPath}>{teamLogoImg}</Link>;

    // team name
    let teamName = null;
    if (breakpoints.md) teamName = team.fullName;
    else if (breakpoints.sm)
      teamName = <span title={team.fullName}>{team.obj.abbr}</span>;
    let teamNameLink = <Link to={linkPath}>{teamName}</Link>;

    // adjust if team is currently selected
    let className;
    if (isActive) {
      teamLogoImgLink = teamLogoImg;
      teamNameLink = teamName;
      className = "selected";
    }

    // build rows
    const teamLogoRow = <td className={"center"}>{teamLogoImgLink}</td>;
    const teamNameRow = breakpoints.sm ? <td>{teamNameLink}</td> : null;

    // output
    const key = team.obj.id;
    return (
      <tr key={key} className={className}>
        {teamLogoRow}
        {teamNameRow}
      </tr>
    );
  };

  const boxWidth = breakpoints.md ? "30%" : "20%";
  const boxMargin = breakpoints.md ? "1rem" : "1rem 0.25rem";
  return (
    <Box
      title={"teams"}
      id={"teams"}
      boxWidth={boxWidth}
      style={{ margin: boxMargin, minWidth: "4rem" }}
      centerContent={true}
    >
      {!loaded ? (
        <Loading />
      ) : (
        <table className={"standard"}>
          <tbody>
            {divisionSeasons.map((divSea, i) => {
              const divisionRow = getDivisionRow(divSea);
              const teamRows = divSea.teams.map(getTeamRow);

              return (
                <React.Fragment key={i}>
                  {divisionRow}
                  {teamRows}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </Box>
  );
};

export default TeamList;
